<template>
  <div class="order">
    <div class="order-header">
      <span style="position: absolute; left: 10px; top: 10px" @click="skip2"
        ><el-icon><ArrowLeftBold /></el-icon
      ></span>
      <span style="position: absolute; left: 28px; top: 8px">{{
        data.roleName
      }}</span>
      <div class="order-title">扫码查信息</div>
    </div>
    <!-- <div class="order-information" style="padding-bottom: 0px">
      <div class="order-information-item">
        <span class="order-information-title">网点：</span>
        <div style="width: calc(100vw - 100px)">{{ data.outlets }}</div>
      </div>
    </div> -->
    <div class="order-information" style="padding: 0px 10px">
      <div class="order-information-item">
        <span class="order-information-title">客号：</span>
        <div style="width: calc(100vw - 100px)">
          <cusCode @getCusId="getCusId"></cusCode>
        </div>
      </div>
    </div>
    <div
      class="order-information"
      style="justify-content: space-between; padding-top: 0px"
    >
      <div class="order-information-item">
        <span class="order-information-title">扫码：</span>
        <el-input
          v-model="data.barcode"
          placeholder="扫一扫条码/输入条码"
          style="width: calc(100vw - 100px)"
          @blur="changeBarcode"
        />
      </div>
      <!-- <div class="order-information-item" @click="onSearch">
        <el-button type="primary" size="small">搜索</el-button>
      </div> -->
    </div>
    <div style="font-weight: 600; margin-left: 10px">
      总条码数：{{ data.infoList.length }}
    </div>
    <div class="order-body">
      <div
        class="order-item2"
        v-for="(item, index) in data.infoList"
        @touchstart="touchStartEvent"
        @touchend="touchEndEvent($event, item)"
      >
        <div
          style="
            margin-bottom: 5px;
            display: flex;
            justify-content: space-between;
          "
        >
          <div>{{ item.total_code }}</div>
          <div style="text-align: right" class="blue">{{ item.barcode }}</div>
          <el-button
            type="danger"
            style="position: relative"
            v-show="item.isDelete"
            @click.stop="deleteInfo(index)"
            >删除</el-button
          >
        </div>
        <div class="info-item">
          <div class="info-item-left">
            <!-- <img
              style="max-width: 35vw; max-height: 40vw"
              :src="data.info.img"
              alt=""
              :preview-src-list="[item.img]"
            /> -->
            <el-image
              style="max-width: 35vw; max-height: 40vw"
              :src="item.img"
              @error="handleImageError"
            >
              <template #error>
                <div class="image-slot" @click="reloadImage(item)">
                  <div class="image-error">
                    <span>加载失败，点击重试</span>
                  </div>
                </div>
              </template>
            </el-image>
            <div>{{ item.goods_code }}</div>
          </div>
          <div class="info-item-right">
            <div style="font-weight: 600">
              克重：{{ item.weight }} 克
            </div>
            <div style="font-weight: 600">
              克工费：{{ item.weight_rate }} 元/克
            </div>
            <div style="font-weight: 600">
              件工费：{{ item.piece_rate }} 元/件
            </div>
            <div style="font-weight: 600">
              基础克工费：{{ item.jckgf }} 元/克
            </div>
            <div style="font-weight: 600">
              整件总工费：<span class="red">{{ item.money }}</span> 元
            </div>
            <div v-for="items in item.item">
              {{ items.name + "：" + items.value }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { reactive, onMounted, nextTick } from "vue";
import { useRouter } from "vue-router";
import cusCode from "@/components/cusCode.vue";
import { getoutlets, scan_barcode } from "@/api/checkinfo";
const router = useRouter();
const data = reactive({
  param: {
    cus_id: "",
    status: "",
  },
  roleName: "",
  outlets: "",
  value3: true,
  barcode: "",
  info: {
    barcode: "",
    goods_code: "",
    img: "",
    item: [],
    piece_rate: "",
    total_code: "",
    weight_rate: "",
    weight:""
  },
  infoList: [],
  startX: 0, // 触摸开始的X坐标
  endX: 0, // 触摸结束的X坐标
  threshold: 150, // 滑动的阈值
  item_id: 0,
  item: {},
});
const skip2 = () => {
  router.push({ path: `/index` });
};
const getCusId = (cus_id) => {
  data.param.cus_id = cus_id;
  if (data.barcode) {
    getScanBarcode();
  }
};
const getOutlets = async () => {
  const res = await getoutlets();
  if (res && res.status && res.data.code >= 1) {
    data.outlets = res.data.data.name;
  }
};
const onSearch = () => {
  getScanBarcode();
};
const getScanBarcode = async () => {
  const res = await scan_barcode({
    cus_id: data.param.cus_id,
    barcode: data.barcode,
  });
  if (res && res.status && res.data.code >= 1) {
    data.info = res.data.data;
    data.infoList.unshift({
      ...res.data.data,
      isDelete: false,
      item_id: data.item_id,
    });
    data.item_id += 1;
    console.info(data.infoList, "data.infoList");
  }
};
const changeBarcode = () => {
  if (data.barcode && data.info.barcode != data.barcode) {
    getScanBarcode();
  }
};
const deleteInfo = (index) => {
  data.infoList.splice(index, 1);
};
const touchStartEvent = (event) => {
  // data.item.isDelete = false;
  data.startX = event.touches[0].clientX;
};
const touchEndEvent = (event, item) => {
  // setTimeout(() => {
  //   data.item.isDelete = false;
  // },100)
  if (data.item.item_id != item.item_id) data.item.isDelete = false;
  data.item = item;
  data.endX = event.changedTouches[0].clientX;
  if (data.startX - data.endX > 10) item.isDelete = true;
  if (data.endX - data.startX > 10) item.isDelete = false;
};
const handleImageError = () => {
  console.log("图片加载失败");
};
const reloadImage = (item) => {
  // 通过临时修改URL强制重新加载
  const img = item.img;
  item.img = "";
  nextTick(() => {
    item.img = img;
  });
};
onMounted(() => {
  data.roleName = sessionStorage.getItem("roleName");
  getOutlets();

  // 监听函数
  window.globalFunction = (data2) => {
    // console.log(data, "外部函数被调用了！");
    data.barcode = data2;
    if (data.barcode) {
      getScanBarcode();
    }
    // 你可以在这里做更多的事情
  };
});
</script>
<style scoped>
@import url("../assets/css/order.css");
.order {
  width: 100vw;
  height: 100vh;
}
.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 5px 10px;
}
.order-title {
  margin: 0 auto;
  font-weight: 600;
  /* position: absolute;
  left: calc(50% - 32px); */
  font-size: 16px;
}
.order-information {
  padding: 10px;
  color: #333;
  display: flex;
}
.order-information .order-information-item {
  /* line-height: 25px; */
  display: flex;
  /* margin-top: 10px; */
  align-items: center;
  margin-top: 10px;
  margin-right: 10px;
  /* justify-content: space-between; */
}
.order-body {
  padding: 5px 10px;
  height: calc(100vh - 212px);
  overflow-y: auto;
}
.order-item2 {
  background-color: #fff;
  padding: 7px 10px;
  box-shadow: 2px 2px 10px 2px #ebe9e9;
  border-radius: 5px;
  margin-bottom: 10px;
  /* display: flex;
  align-content: center;
  justify-content: space-between; */
}
.info-item {
  display: flex;
}
.info-item-left {
  width: 35vw;
}
.info-item-right {
  width: calc(65vw - 50px);
  margin-left: 10px;
}
.blue {
  color: #409eff;
}
.red {
  color: #f56c6c;
}
.image-error {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  cursor: pointer;
}
.image-error:hover {
  color: #409eff;
}
</style>
